module.exports = __webpack_public_path__ + "img/finagent-details-icon-dark.60efd45.svg";